/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ confirmed: NonNullable<unknown>, waitlist: NonNullable<unknown> }} Signupcounts1Inputs */

const en_signupcounts1 = /** @type {(inputs: Signupcounts1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.confirmed} signed up · ${i?.waitlist} on the waiting list`)
};

const de_signupcounts1 = /** @type {(inputs: Signupcounts1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.confirmed} angemeldet · ${i?.waitlist} auf der Warteliste`)
};

/**
* | output |
* | --- |
* | "{confirmed} signed up · {waitlist} on the waiting list" |
*
* @param {Signupcounts1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupcounts1 = /** @type {((inputs: Signupcounts1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupcounts1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupcounts1(inputs)
	return de_signupcounts1(inputs)
});
export { signupcounts1 as "signupCounts" }